import { createContext, useContext } from 'react'

const StaticDataContext = createContext(null)

const StaticDataProvider = StaticDataContext.Provider

const useStaticDataContext = () => {
  const context = useContext(StaticDataContext)
  if (context === undefined) {
    throw new Error('useStaticDataContext must be used within a StaticDataProvider')
  }
  return {
    ...context,
  }
}

export { StaticDataProvider, useStaticDataContext }
